import { IAttribute } from "../../model/formconfiguration/Attribute";
import { IAttributeService } from "../../service/formconfiguration/AttributeService";

export default class UpdateAttributeInteractor {
  private attributeService: IAttributeService;

  constructor(attributeService) {
    this.attributeService = attributeService;
  }

  async execute(attribute: IAttribute) {
    await this.attributeService.updateAttribute(attribute);
  }
}
